// Redux Related
import { AppThunk } from '../../ThunkTypes';
import {
  updatePolicyMenuUnderstood,
  updateFilterUnderstood,
  updateProfileUnderstood,
} from '../slice';

export const setPolicyMenuUnderstood =
  (): AppThunk =>
  (dispatch): void => {
    dispatch(updatePolicyMenuUnderstood(true));
  };

export const setFilterMenuUnderstood =
  (): AppThunk =>
  (dispatch): void => {
    dispatch(updateFilterUnderstood(true));
  };

export const setProfileUnderstood =
  (): AppThunk =>
  (dispatch): void => {
    dispatch(updateProfileUnderstood(true));
  };

export const setInitialProfileUnderstood =
  (isUnderstood: boolean): AppThunk =>
  (dispatch): void => {
    dispatch(updateProfileUnderstood(isUnderstood));
  };
